import dayjs from 'dayjs';
import {capitalize} from '@utils/index';
import {toFullDayName} from './cadence-payload';
import {UI_SELECTED_DAYS_FREQUENCY} from './cadence-frequency';
import {CadenceFormState} from './types';
import {CadenceDetails} from './preview-step.types';

const formatSendTime = (time: string, period: string) => {
  if (!time) return '';
  return `${time} ${period || ''}`.trim();
};

const formatDateForDisplay = (value?: string | null) => {
  if (!value) return '';
  const parsed = dayjs(value);
  return parsed.isValid() ? parsed.format('MMM D, YYYY') : value;
};

export const formatCadenceDetails = (
  cadence: CadenceFormState,
): CadenceDetails => {
  const frequencyLabel = cadence.frequency
    ? cadence.frequency === UI_SELECTED_DAYS_FREQUENCY
      ? 'Selected days'
      : capitalize(cadence.frequency.replace('-', ' '))
    : '';

  const startLabel =
    cadence.startOption === 'specific'
      ? formatDateForDisplay(
          cadence.frequency === 'one-time'
            ? cadence.oneTimeDate
            : cadence.startDate,
        ) || ''
      : cadence.startOption === 'immediately'
      ? 'Immediately'
      : '';

  let sendOnLabel = cadence.selectedDay
    ? toFullDayName(cadence.selectedDay)
    : '';
  if (cadence.frequency === 'one-time') {
    sendOnLabel = '';
  } else if (cadence.frequency === 'daily') {
    sendOnLabel = 'Every day';
  } else if (cadence.frequency === UI_SELECTED_DAYS_FREQUENCY) {
    sendOnLabel = cadence.selectedDays.map(toFullDayName).join(', ');
  } else if (cadence.frequency === 'monthly' && cadence.monthlySpecificDay) {
    sendOnLabel = `Day ${cadence.monthlySpecificDay}`;
  } else if (cadence.frequency === 'monthly' && cadence.selectedDay) {
    sendOnLabel = toFullDayName(cadence.selectedDay);
  }

  const endLabel =
    cadence.frequency === 'one-time'
      ? ''
      : cadence.endOption === 'after'
      ? cadence.occurrences
        ? `After ${cadence.occurrences} occurrences`
        : ''
      : cadence.endOption === 'specific'
      ? formatDateForDisplay(cadence.endDate) || ''
      : cadence.endOption === 'never'
      ? 'Never'
      : '';

  const sendTime = formatSendTime(
    cadence.selectedTime.time,
    cadence.selectedTime.period,
  );
  const timeLabel =
    cadence.frequency === 'one-time' || !sendTime
      ? ''
      : `${sendTime} (${
          cadence.timezone === 'workspace'
            ? 'workspace time'
            : "each participant's local time"
        })`;

  return {
    frequencyLabel,
    startLabel,
    sendOnLabel,
    endLabel,
    timeLabel,
  };
};
